const ameliUrl = process.env.AMELI_URL

var resources = {
    title : 'Votre simulation de remboursement',

    /* Toaster.vue & Errors & global */
    standardErrorMessage : 'Le service est indisponible, merci de réessayer plus tard.',
    technicalErrorMessage : 'Une erreur est intervenue, merci de réessayer plus tard.',
    standardErrorTitle : 'Service indisponible',
    chooseCare : 'Choisissez la nature de l\'acte :',

    /* Home.vue */
    startSimulation : 'Combien serais-je remboursé(e) ?',
    startSimulation2 : 'Choisir mes soins :',
    understandSimulation : 'Mieux comprendre votre simulation',
    backToUserAccount : 'Retour sur mon espace',

    /* Mentions */
    attentionPointIntro : 'Points d’attention avant utilisation du simulateur',
    attentionPoints : ['Les montants mentionnés ne constituent pas un engagement contractuel sur les remboursements auxquels vous pourriez prétendre au titre de votre contrat santé.',
        'Les forfaits, nombres d’actes déjà consommés et les limitations (âge, …) ne sont pas pris en compte.',
        'Les montants de remboursements simulés ne tiennent pas compte de la possibilité de bénéficier de l’application de la réforme 100% Santé / Reste à Charge 0.'],

    /* Redirect.vue */
    pageDoesntExist : 'Cette page n\'existe pas !',
    sessionExpired : 'Votre session a expiré, merci de vous reconnecter',
    backToHomePage : 'Retour à l\'accueil',
    login : 'Se connecter',

    /* Results.vue */
    totalSpent : 'Votre dépense',
    socialSecurityRefund : 'Remboursement par la Sécurité Sociale',
    complementaryRefund : 'Remboursement par la Complémentaire Santé',
    optamInfo : 'Pour savoir si votre médecin pratique des dépassements maîtrisés (OPTAM ou OPTAM-CO), il suffit de consulter <a href="' + ameliUrl + '" target="_blank">Ameli.fr</a> <br>Si c’est le cas, la mention « honoraires avec dépassements maîtrisés » s’affiche. <br>Le remboursement des consultations s’entend dans le respect du parcours de soins. La participation forfaitaire de 1 € s’applique quel que soit le médecin consulté si vous avez plus de 18 ans. ',
    leftToPay : 'Votre reste à charge',
    positiveAmountValidationMessage : "Veuillez saisir un montant positif.",
    requiredAmountValidationMessage : "Veuillez saisir un montant.",
    requiredValueValidationMessage : "Veuillez choisir une valeur.",

    /* ComplexResults.vue */
    OPTAM : 'Médecin ayant adhéré à l\'OPTAM',
    nonOPTAM : 'Médecin n\'ayant pas adhéré à l\'OPTAM',
    simpleGlass : 'Monture + 2 verres simples',
    complexGlass : 'Monture + 2 verres complexes',
    veryComplexGlass : 'Monture + 2 verres très complexes',

    /* Action.vue */
    backToSimulatorHome : 'Retour à l\'accueil du simulateur',
    simulateRefund : 'Simuler le remboursement',
    newSimulation : 'Nouvelle simulation',
    modifyForm : 'Modifier ma saisie',

    /* CommonForm.vue */
    simulationDate : 'Date de la simulation :',

    /* DentalCare.vue */
    orthodonticsType : 'Quel type d\'orthodontie ?',
    orthodonticsTypeTooltip : '<strong>Orthodontie acceptée :</strong> sous réserve d’obtenir l’accord préalable de la Sécurité Sociale et de démarrer le traitement avant le 16ème anniversaire. <br><strong>Orthodontie refusée :</strong> sous réserve de prise en charge dans le cadre des conditions de garanties de votre contrat disponible sur votre espace adhérent.',
    personType : 'Personne concernée',
    orthodonticsSpendings : 'Quel est le montant de vos dépenses d\'orthodontie par semestre ?',
    crownAmount : 'Quel est le montant de la couronne ?',
    orthodonticsTooltip : 'Indiquer le montant pour un seul semestre de traitement.',
    crown : 'Couronne dentaire',
    crownMentions : 'Le tarif d’une couronne dentaire est libre et dépend des matériaux utilisés. Cette simulation se limite donc à un acte simple. <br>Il est fortement recommandé de nous  adresser un devis. Pour rappel, votre dentiste doit également vous présenter un devis 100% santé.',
    orthodontics : 'Orthodontie',
    orthodonticsMentions : 'L’orthodontie est remboursée par la Sécurité Sociale sous condition que le traitement ait débuté avant l’âge de 16 ans. <br>Au-delà la Sécurité Sociale n’effectue aucun remboursement.',

    /* Hospitalization.vue */
    contactUs : 'Nous contacter.',
    conditionsAreAvailable : 'Les conditions de votre contrat sont accessibles sur votre espace adhérent.',
    hospitalRoomInfo : 'Les frais de la chambre particulière ne sont pas pris en charge par le régime obligatoire sécurité sociale.',
    hospitalization:'Hospitalisation',
    hospitalizationMentions:'La simulation ne concerne pas les établissements spécialisés (psychiatrie, maison de repos, etc.). <br>Pour les dépassements d’honoraires du chirurgien et de l’anesthésiste et en cas de maternité, nous vous conseillons de nous faire parvenir un devis détaillé.',
    dailyHospitalFees : 'Quel est le montant de vos frais journaliers ?',

    /* MedicalCare.vue */
    medicalCareAmount : 'Quel est le montant de la consultation ?',
    medicalCareOptamOrNot : 'OPTAM / Non OPTAM ',
    medicalCareMentionsTitle : 'Consultations',
    medicalCareMentions : 'La nature d’acte « Spécialiste » regroupe les spécialités suivantes : gynécologue, ophtalmologue, dermatologue, urologue, pneumologue, etc.',

    /* OpticalCare.vue */
    simpleGlassTooltip : 'Verres simples : correction pour un seul trouble de la vue (ex. myopie)',
    complexGlassTooltip : 'Verres complexes : correction de 2 ou 3 troubles de la vue (ex. myopie et presbytie : verres progressifs)',
    veryComplexGlassTooltip : 'Verres très complexes : correction de 2 ou 3 troubles de la vue (ex. très forte myopie, très forte myopie + presbytie)',
    glassesFramePrice : 'Quel est le prix d\'achat de la monture + de 2 verres ?',
    lensType : 'Quel est le type de lentilles ?',
    lensTooltip : 'Lentilles acceptées : lentilles sur prescription médicale réservées à des corrections précises.',
    annualLensPrice : 'Quel est le prix d\'achat annuel de vos lentilles ?',
    lensMentionsTitle : 'Lentilles',
    lensMentionsText : 'Les lentilles refusées par la Sécurité Sociale peuvent être prises en charge par votre contrat de complémentaire santé. <br>Dans ce cas, il est généralement prévu un forfait annuel par ayant-droit inscrit.',
    glassesMentionsTitle : 'Equipement optique',
    glassesMentionsText : 'Cette simulation donne une estimation minimum et maximum et ne tient pas compte du montant de forfait déjà utilisé dans les 2 ans. <br>Il est fortement  recommandé de nous  adresser un devis du fait que le remboursement complémentaire santé varie en fonction du degré de correction. Pour rappel, votre opticien doit également vous présenter un devis 100% santé.',

}

export default resources


// WEBPACK FOOTER //
// ./src/helpers/resources.js